import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileUploadRequest, FileStorageInfo } from "@app/models/commonfilestorage.model";
import { Observable, tap, catchError } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { BaseService } from "../base/base.service";
import { FileNote } from "@app/models/commonfilestorage.model";

@Injectable({
  providedIn: "root",
})
export class CommonFileStorageService extends BaseService {
  //readonly BASE_URL = `https://localhost:7062/v1/gateway/files/FileStorage/`;
  readonly BASE_URL = `${environment.gatewayAPI_V1}/files/FileStorage/`;///multipart/files
  readonly BASE_URL_MULTIPART_UPLOAD = `${environment.gatewayAPI_V1}/multipart/files/FileStorage/`;
  constructor(private httpClient: HttpClient) {
    super();
  }

  public GetPhotoUploadReasons(partnerId: string): Observable<FileNote[]> {
    const headers = new HttpHeaders({
      'x-partner-id': partnerId
    });
    const url = `${this.BASE_URL}GetFileNotesByTypeCode?typeCode=SD`;

    return this.httpClient.get<FileNote[]>(url, { headers }).pipe(
      tap(_ => _),
      catchError(this.handleError)
    );
  }
  
  public UploadFile(request: FileUploadRequest, file: File, partnerId: string): Observable<FileStorageInfo> {
    const headers = new HttpHeaders({
      'x-partner-id': partnerId,
    });
    const formData = new FormData();
    const url = `${this.BASE_URL_MULTIPART_UPLOAD}UploadFile`;

    formData.append('file', file, file.name);

    Object.entries(request).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, String(value));
      }
    });

    return this.httpClient.post<FileStorageInfo>(url, formData,{ headers }
    ).pipe(
      tap(_ => _),
      catchError(this.handleError)
    );
  }

  public GetFileStorageInfosByReferenceTypeAndIds(referenceType: string, referenceIds: string, partnerId: string, includeBase64String: boolean = false): Observable<FileStorageInfo[]> 
  {
    const headers = new HttpHeaders({
      'x-partner-id': partnerId
    });
    const url =`${this.BASE_URL}GetFileStorageInfosByReferenceTypeAndIds` +
      `?referenceType=${referenceType}` +
      `&referenceIds=${referenceIds}` + 
      `&includeBase64String=${includeBase64String}`;

    return this.httpClient.get<FileStorageInfo[]>(
      url,
      { headers }
    ).pipe(
      tap(_ => _),
      catchError(this.handleError)
    );
  }

  public DeleteFileById(fileId: string, partnerId: string): Observable<boolean> {
    const headers = new HttpHeaders({
      'x-partner-id': partnerId
    });
    const url = `${this.BASE_URL}DeleteFileById?id=${fileId}`;

    return this.httpClient.delete<boolean>(url, { headers }).pipe(
      tap(_ => _),
      catchError(this.handleError)
    );
  }
}